import { Pipe, PipeTransform } from '@angular/core';
import * as momentTz from 'moment-timezone';
import * as moment from 'moment';
import { READABLE_SUPPORTED_DATE_FORMATS } from '@app-core/constants/constants';
import { getClientConfig } from '@config/client-config';

@Pipe({
  name: 'dateConversion',
})
export class DateConversionPipe implements PipeTransform {
  public readonly env = getClientConfig().environments;
  public transform(
    value: any,
    timeZone: string = 'Local',
    format = 'MM/DD/YYYY HH:mm:ss',
    isReadableFormat: boolean = false,
    defaultValue?: any
  ): any {
    let appliedFormat = format;

    if (!this.env.isGeotabEnv && isReadableFormat) {
      const readableFormat = READABLE_SUPPORTED_DATE_FORMATS.find((f) => f.key === format);
      if (readableFormat) {
        appliedFormat = readableFormat.value;
      }
    }

    // if (format !== 'HH:mm' && !isReadableFormat) {
    //   appliedFormat = appliedFormat.replace(/[\s:/.-]?(HH|mm|ss)/g, '').trim();
    // }

    if (timeZone === 'Local') {
      if (defaultValue) {
        return momentTz.tz(defaultValue, 'UTC').format(appliedFormat);
      } else if (value) {
        return moment.utc(value).local().format(appliedFormat);
      }
      return '';
    }

    if (value) {
      return momentTz.tz(value, timeZone).format(appliedFormat);
    }

    return '';
  }
}
